import { Component } from '@angular/core';

@Component({
  selector: 'app-annule-fac-f',
  templateUrl: './annule-fac-f.component.html',
  styleUrls: ['./annule-fac-f.component.scss']
})
export class AnnuleFacFComponent {}
